@if (data(); as data) {

  <evland-modal-container (onClose)="onClose()" [title]="data.title" [withFooter]="true">

    <div class="d-flex flex-column gap-2">

      @if (data.message; as message) {
        <div class="message" [innerHTML]="message"></div>
      }

      @if (data.hint; as hint) {
        <div class="hint" [innerHTML]="hint"></div>
      }

      @if (data.tip; as tip) {
        <div class="tip" [innerHTML]="tip"></div>
      }

    </div>

    <div class="d-flex flex-column flex-md-row justify-content-start justify-content-md-end gap-2" modal-footer>

      <button (click)="onGuestClick()" class="btn btn-outline-secondary" i18n>Продовжити як гість</button>

      <button (click)="onSignInClick()" class="btn btn-primary" i18n>Авторизуватися</button>

    </div>

  </evland-modal-container>

}
